<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'material-materialInfoSet',
  components: {
    PageTable,
  },
}
</script>
